module.exports = "images/apple-icon-76x76.f34c18a7b90d80749bde94761b16ff7a.png";